<script lang="ts">
    import type {LoanRequestOption, MailRequestability} from 'typings/portaro.be.types';
    import {getLocalization, getSanitize} from 'core/svelte-context/context';
    import KpGenericPanel from 'shared/ui-widgets/panel/KpGenericPanel.svelte';
    import SendLoanRequestButton from './shared/SendLoanRequestButton.svelte';
    import LoanOptionPanelBody from './shared/LoanOptionPanelBody.svelte';

    export let option: LoanRequestOption<MailRequestability>;

    const localize = getLocalization();
    const htmlSanitize = getSanitize();
</script>

<KpGenericPanel>
    <strong slot="heading">
        {localize(/* @kp-localization loan.mail.RequestByMail */ 'loan.mail.RequestByMail')}
    </strong>

    <LoanOptionPanelBody>
        <div>
            {@html htmlSanitize(localize(/* @kp-localization loan.mail.SendOrderMail */ 'loan.mail.SendOrderMail'))}
        </div>

        <SendLoanRequestButton {option} apiPath="/loan-requests/mail/create">
            {localize(/* @kp-localization loan.mail.SendMail */ 'loan.mail.SendMail')}
        </SendLoanRequestButton>
    </LoanOptionPanelBody>
</KpGenericPanel>